// Firebase configuration and initialization
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Your Firebase config object using environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDxnR2nKirLhW9Z2W-P3O6N-qCDLFdF-hE",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || window.location.hostname,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "chess-web-host",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "chess-web-host.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "730860748863",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:730860748863:web:ee501cd4ae2c0b1eb6788a"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Initialize Firebase Storage
export const storage = getStorage(app);

// Export the app for other uses if needed
export default app; 